import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import style from './style.module.scss'

const Page403 = ({ intl: { formatMessage } }) => {
  return (
    <div className={style.wrapper}>
      <Helmet title={formatMessage({ id: 'page.403.title-short' })} />
      <div className={style.body}>
        <h1>403</h1>
        <h1>{formatMessage({ id: 'page.403.description' })}</h1>

        <Link to="/" className="btn">&larr; {formatMessage({ id: 'page.403.go-home' })}</Link>
      </div>
    </div>
  )
}

export default errorBoundaryEnhancer(injectIntl(Page403))
